import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "../layout/HomeSlider/bootstrap-component";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import Lang from "../../userPreferences/staticWords";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllLinksAPI,
  getLinkAPI,
} from "../../API/store/actions/agendaAndLinks";
import { deleteLink } from "../../API/services/agendaAndLinks";
import LinksForm from "./LinksForm";
import Titlebar from "../layout/titlebar";

const LinksManagment = () => {
  const [linksLoading, setLinksLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showLinksModal, setShowLinksModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();
  const userToken = useSelector((state) => state.login.userToken);
  const user = useSelector((state) => state.login.userData);

  const [deleting, setDeleting] = useState(false);

  const [deleteType, setDeleteType] = useState(null);

  const fetchLinks = async () => {
    setLinksLoading(true);

    try {
      const payload = {
        active: true,
      };

      const action = await getAllLinksAPI(payload, userToken);
      dispatch(action);
    } finally {
      setLinksLoading(false);
    }
  };
  useEffect(() => {
    fetchLinks();
  }, [userToken]);
  const links = useSelector((state) => state.links.links);
  const filteredLinks = (links || []).filter((item) =>
    item.name?.toLowerCase().includes((searchValue || "").toLowerCase()),
  );
  const handleDelete = async () => {
    setDeleting(true);

    try {
      const payload = {
        id: deleteId,
        modifierId: user.id,
      };

      if (deleteType === "link") {
        await deleteLink(payload, userToken);
        await fetchLinks();
      }

      setShowDeleteModal(false);
      setDeleteId(null);
      setDeleteType(null);
    } catch (err) {
      console.log(err);
    } finally {
      setDeleting(false);
    }
  };
  return (
    <div>
      <Titlebar title={Lang.links} customImage={"/assets/images/links.svg"} />
      <div className="container-fluid px-2 ">
        <div className="row g-4 align-items-start align-items-lg-center">
          <div className="col-10">
            <div style={{ width: "100%", marginTop: 10, padding: "0 20px" }}>
              <input
                type="text"
                placeholder={Lang.search}
                className="form-control"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>
            <div className="card-body report_table table-scroll">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>اسم الموقع</th>
                    <th>الرابط</th>
                    <th width="100" className="text-center">
                      الإجراءات
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {linksLoading ? (
                    <tr>
                      <td colSpan="3" className="text-center">
                        <div className="spinner-border text-success" />
                      </td>
                    </tr>
                  ) : filteredLinks?.length ? (
                    filteredLinks?.map((item) => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>
                          <a
                            href={item.siteUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-black"
                          >
                            {item.url}
                          </a>
                        </td>

                        <td className="d-flex justify-content-center gap-2">
                          <button
                            type="button"
                            className="border-0 bg-transparent"
                            title={Lang.edit}
                            onClick={async () => {
                              const action = await getLinkAPI(
                                item.id,
                                userToken,
                              );

                              dispatch(action);

                              setIsEdit(true);
                              setShowLinksModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} />
                          </button>
                          <button
                            type="button"
                            className="border-0 bg-transparent"
                            title={Lang.delete}
                            onClick={() => {
                              setDeleteId(item.id);
                              setDeleteType("link");
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        لا توجد بيانات
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-12 col-lg-auto d-flex justify-content-center">
            <CardWithTitleAndIcon
              containerStyle={`d-flex row align-self-center justify-content-center align-items-center p-2`}
              onClick={() => {
                setIsEdit(false);
                setShowLinksModal(true);
              }}
              customImage={"/assets/images/links.svg"}
              cardTitle={Lang.createLink}
              height={150}
              width={180}
              imgHeight={70}
              imgWidth={80}
              containerImgHeight={70}
              containerImgWidth={80}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
              borderColor={"rgba(68, 68, 68, 0.25)"}
            />
          </div>
        </div>
      </div>
      <LinksForm
        show={showLinksModal}
        setShow={setShowLinksModal}
        isEdit={isEdit}
        onSuccess={fetchLinks}
      />
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        style={{ direction: getDir(getCurrentLangFromRedux()) }}
        centered
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="fw-bold text-danger"
          >
            <div className="d-flex align-items-center mx-md-3 mx-1">
              <div
                className="mx-2 d-flex justify-content-center align-items-center"
                style={{
                  height: 32,
                  width: 32,
                }}
              >
                <img
                  src="/assets/images/deleteicon.png"
                  width={20}
                  height={20}
                  alt=""
                />
              </div>
              <div className="text-dark d-flex align-content-center">
                <p
                  className="my-0 "
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "rgb(12, 87, 76)",
                  }}
                >
                  {" "}
                  {Lang.deleteTitle}
                </p>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <div className=" d-flex flex-column  align-items-center justify-content-center">
          <img src="/assets/images/fi-br-info.png" />
          <div className="my-2">{Lang.deleteMessage}</div>
          <div className="d-flex justify-content-center flex-wrap w-100 my-3">
            <Button
              containerStyle={"col-3 mx-2"}
              content={getDir(getCurrentLangFromRedux()) == "rtl" ? "لا" : "No"}
              onClick={() => setShowDeleteModal(false)}
            />
            <Button
              containerStyle={"col-3 mx-2 "}
              content={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "نعم" : "Yes"
              }
              buttonStyleType={"solid"}
              disable={deleting}
              onClick={handleDelete}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LinksManagment;
